var $becca56e8be70da0$exports = {};
$becca56e8be70da0$exports = {
    "info": `Inform\xe1ci\xf3`,
    "negative": `Hiba`,
    "positive": `Siker`
};


export {$becca56e8be70da0$exports as default};
//# sourceMappingURL=hu-HU.mjs.map
